import React, { Component } from "react";
import { withStyles } from "@mui/styles";
import {
  Button,
  Box,
  Paper,
  Grid,
  Table,
  TableRow,
  TableCell,
  Slide,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormLabel,
  Dialog,
  DialogContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  InputLabel,
  MenuItem,
  Select,
  AppBar,
} from "@mui/material";
import LOCATION_TYPE from "../enum/location_type";
import classNames from "classnames";
import { withTranslation } from "react-i18next";
import styles from "./index.styles";
import spinner from "../assign-prescriptions/images/spinner.gif";
import randomized from "randomatic";
import AddIcon from "@mui/icons-material/Add";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ILocalAGGrid from "../grid/iLocalAGGrid";
import BoxLayout from "../assign-prescriptions/box-layout";
import BOX_TYPE from "../enum/box_type";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import PrintTemplate from "react-print";
import RetailLabelTemplate from "./printTemplate";
import assignmentStatus from "../assign-prescriptions/assignment-status";
import EVENT_TYPES from "../common/event-type";
import EVENT_CRUD_TYPES from "../common/event-crud-types";
import CircularProgress from '@mui/material/CircularProgress';
import userroles from "../common/userroles";

let TableObj = {
  bin_id: { tableName: "orders", sortColumn: "bin_id" },
  invoice_id: { tableName: "orders", sortColumn: "invoice_id" },
  profile_id: { tableName: "icustomers", sortColumn: "profile_id" },
};

export class CreateOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      stock_code: "",
      pickup_code: "",
      isCreteOrderDialogOpened: true,
      BinStatus: [],
      expansionUnits: [],
      deactivatedBins: [],
      selectedBinId: "",
      box_id: "",
      profile_id: "",
      phone_number: "",
      email: "",
      boxDetails: [],
      courier_type: [],
      default_courier_selected: "",
      order: [
        {
          invoice_number: "",
          item: "",
          sunglasses: false,
          eyeglasses: false,
          contacts: false,
          special_order: false,
        },
      ],
      locker_id: "",
      rowdata: [],
      items: [],
      searchedItems: [],
      printDialogOpen: false,
      orderDetails: [],
      view: false,
      isChecked:false,
      errortext:'',
      orderId:'',
      orderStatus:'',
      remindLoader:false,
      prescriptionUnAssign: true,
      prescriptionAssign: true,
      prescriptionView: true,
      prescriptionDirectPickup: true,
      prescriptionRemind: true,
      prescriptionConsult: true,
      prescriptionHoldResume: true,
      prescriptionAcDc: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  setPermission = () => {
    let permissions = JSON.parse(sessionStorage.getItem("permissions"));
    let _checkUserRole = JSON.parse(sessionStorage.getItem("permissionUser"));
    if(_checkUserRole === userroles.SUPERADMIN) {
      this.setState({ 
        isManualOverridePermissionEnabled: true, 
        prescriptionUnAssign: true, 
        prescriptionAssign: true, 
        prescriptionView: true,
        prescriptionDirectPickup: true,
        prescriptionRemind: true,
        prescriptionConsult: true,
        prescriptionHoldResume: true,
        prescriptionAcDc: true, });
    } else {
      if (permissions && permissions.length > 0) {
        const manualOverride = permissions.filter((item) => {
          return item.permission_entity_type === "Manual Override"
        });
        const assignPrescriptions = permissions.filter((item) => {
          return item.permission_entity_type === "Assign Prescription"
        });
        if(manualOverride.length > 0) {
          const isOpenBinAllowed = manualOverride.filter((x) => x.name.trim() === 'Open Bin' && x.is_allowed === 1);
          // Open Bin
          if(isOpenBinAllowed.length > 0) {
            this.setState({ isManualOverridePermissionEnabled: true })
          } else {
            this.setState({ isManualOverridePermissionEnabled: false })
          }
        } else {
          this.setState({ isManualOverridePermissionEnabled: false });
        }

        if(assignPrescriptions.length > 0) {
          const isUnAssignAllowed = assignPrescriptions.filter((x) => x.name.trim() === 'UnAssign' && x.is_allowed === 1);
          const isAssignAllowed = assignPrescriptions.filter((x) => x.name.trim() === 'Assign' && x.is_allowed === 1);
          const _isViewPermissionAllowed = assignPrescriptions.filter((x) => x.name.trim() === 'View' && x.is_allowed === 1);

          const _isRemind = assignPrescriptions.filter((x) => x.name.trim() === 'Remind' && x.is_allowed === 1);
          const _isDirect = assignPrescriptions.filter((x) => x.name.trim() === 'Direct Pickup' && x.is_allowed === 1);
          const _isConsult = assignPrescriptions.filter((x) => x.name.trim() === 'Consult' && x.is_allowed === 1);
          const _isAcDc = assignPrescriptions.filter((x) => x.name.trim() === 'Activate/DeActivate' && x.is_allowed === 1);
          const _isHoRu = assignPrescriptions.filter((x) => x.name.trim() === 'Hold/Resume' && x.is_allowed === 1);
          
          // UnAssign
          if(isUnAssignAllowed.length > 0) {
            this.setState({ prescriptionUnAssign: true })
          } else {
            this.setState({ prescriptionUnAssign: false })
          }
          // Assign
          if(isAssignAllowed.length > 0) {
            this.setState({ prescriptionAssign: true })
          } else {
            this.setState({ prescriptionAssign: false })
          }
          // View
          if(_isViewPermissionAllowed.length > 0) {
            this.setState({ prescriptionView: true })
          } else {
            this.setState({ prescriptionView: false })
          }
          // Remind
          if(_isRemind.length > 0) {
            this.setState({ prescriptionRemind: true })
          } else {
            this.setState({ prescriptionRemind: false })
          }
          // Direct Pickup
          if(_isDirect.length > 0) {
            this.setState({ prescriptionDirectPickup: true })
          } else {
            this.setState({ prescriptionDirectPickup: false })
          }
          // Consult
          if(_isConsult.length > 0) {
            this.setState({ prescriptionConsult: true })
          } else {
            this.setState({ prescriptionConsult: false })
          }
          // Activate/DeActivate
          if(_isAcDc.length > 0) {
            this.setState({ prescriptionAcDc: true })
          } else {
            this.setState({ prescriptionAcDc: false })
          }
          // Hold/Resume
          if(_isHoRu.length > 0) {
            this.setState({ prescriptionHoldResume: true })
          } else {
            this.setState({ prescriptionHoldResume: false })
          }
        } else {
          this.setState({ 
            prescriptionUnAssign: false, 
            prescriptionAssign: false, 
            prescriptionView: false,
            prescriptionDirectPickup: false,
            prescriptionRemind: false,
            prescriptionConsult: false,
            prescriptionHoldResume: false,
            prescriptionAcDc: false,
          });
        }
      } else {
        this.setState({ 
          isManualOverridePermissionEnabled: false, 
          prescriptionUnAssign: false, 
          prescriptionAssign: false, 
          prescriptionView: false,
          prescriptionDirectPickup: false,
          prescriptionRemind: false,
          prescriptionConsult: false,
          prescriptionHoldResume: false,
          prescriptionAcDc: false 
        });
      } 
    }
  }

  componentDidMount() {
    this.ClearFields();
    this.setPermission();
  }

  generateCodes() {
    const _stockCode = randomized("0", 4);
    const _pickupCode = randomized("0", 4);
    this.checkIfCodesExists({
      stock_code: _stockCode,
      pickup_code: _pickupCode,
    });
  }

  checkIfCodesExists = async (codes) => {
    let errorCounter = 0;
    this.handleLoader();
    await fetch(process.env.REACT_APP_BASEURL + "verify/codes", {
      crossDomain: true,
      method: "post",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(codes),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        if (res && res.isExist === true) {
          const _stockCode = randomized("A0", 6, {
            exclude: "0oOiIlL1&zZ",
          });
          const _pickupCode = randomized("A0", 6, {
            exclude: "0oOiIlL1&zZ",
          });
          let codes = {
            stockCode: _stockCode,
            pickupCode: _pickupCode,
          };
          localStorage.setItem("label-codes", JSON.stringify(codes));
          this.setState({
            stock_code: _stockCode,
            pickup_code: _pickupCode,
          });
          this.handleLoader();
        } else {
          let _codes = {
            stockCode: codes.stock_code,
            pickupCode: codes.pickup_code,
          };
          localStorage.setItem("label-codes", JSON.stringify(_codes));
          this.setState({
            stock_code: codes.stock_code,
            pickup_code: codes.pickup_code,
          });
          this.handleLoader();
        }
      })
      .catch((error) => {
        errorCounter++;
        console.log(`Error while fetching codes ${error.message}`);
        if (errorCounter === 3) {
          return;
        } else {
          console.log(`Retrying for codes...`);
          this.checkIfCodesExists(codes);
        }
        this.handleLoader();
      });
    return codes;
  };

  ClearFields = () => {
    console.log("Cleared all the fields.");
    this.setState({
      loader: false,
      stock_code: "",
      pickup_code: "",
      BinStatus: [],
      expansionUnits: [],
      deactivatedBins: [],
      selectedBinId: "",
      errortext:"",
      isChecked:false
    });
    this.getLocationTypes(undefined, true, "init");
  };

  handleLoader = () => {
    this.setState({ loader: !this.state.loader });
  };

  handleCreateOrderDialogClose = () => {
    this.setState({
      isCreteOrderDialogOpened: true,
      view: false,
    });
    this.handleReset();
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    const dataSource = {
      getRows: (params) => {
        const count = params.endRow - params.startRow;
        const page = Math.ceil(params.endRow / count - 1);
        const filterModel = this.gridApi.getFilterModel();

        const sortObj = {
          tableName: "orders",
          sortColumn: "created_on",
          sortOrder: "desc",
        };
        if (params.sortModel.length > 0) {
          sortObj.tableName = TableObj[params.sortModel[0].colId].tableName;
          sortObj.sortColumn = TableObj[params.sortModel[0].colId].sortColumn;
          sortObj.sortOrder = params.sortModel[0].sort;
        }

        fetch(
          `${process.env.REACT_APP_BASEURL}apis/i-ecom/orders/${this.state.box_id}`,
          {
            method: "POST",
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user")).signInUserSession
                  .idToken.jwtToken,
            },
            body: JSON.stringify({
              count: count,
              page: page,
              filterModel: filterModel,
              tableName: sortObj.tableName,
              sortColumn: sortObj.sortColumn,
              sortOrder: sortObj.sortOrder,
            }),
          }
        )
          .then((resp) => resp.json())
          .then((data) => {
            const rowsThisPage = data.results;
            let lastRow = -1;
            if (data.total <= params.endRow) {
              lastRow = data.total;
            }
            params.successCallback(rowsThisPage, lastRow);
          })
          .catch((error) => {
            console.error(error);
            params.failCallback();
          });
      },
    };
    params.api.setDatasource(dataSource);
  };

  normalizeInput = (value, previousValue) => {
    if (!value) return value;
    const currentValue = value.replace(/[^\d]/g, "");
    const cvLength = currentValue.length;

    if (!previousValue || value.length > previousValue.length) {
      if (cvLength < 4) return currentValue;
      if (cvLength < 7)
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
        3,
        6
      )}-${currentValue.slice(6, 10)}`;
    }
  };

  handleChange = (e) => {
    if (e.target.name === "phone_number") {
      this.setState({
        [e.target.name]: this.normalizeInput(e.target.value),
      });
      if(e.target.value.length === 14) {
        this.generateCodes();
      }
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  handleOrder = (index, event) => {
    const values = [...this.state.order];
    if (event.target.name === "invoice_number") {
      values[index].invoice_number = event.target.value;
    } else if (event.target.name === "Sunglasses") {
      if (!values[index].sunglasses) {
        values[index].item = event.target.name;
        values[index].sunglasses = true;
        values[index].eyeglasses = false;
        values[index].contacts = false;
        values[index].special_order = false;
      } else {
        values[index].item = "";
        values[index].sunglasses = false;
      }
    } else if (event.target.name === "Eyeglasses") {
      if (!values[index].eyeglasses) {
        values[index].item = event.target.name;
        values[index].sunglasses = false;
        values[index].eyeglasses = true;
        values[index].contacts = false;
        values[index].special_order = false;
      } else {
        values[index].item = "";
        values[index].eyeglasses = false;
      }
    } else if (event.target.name === "Contacts") {
      if (!values[index].contacts) {
        values[index].item = event.target.name;
        values[index].sunglasses = false;
        values[index].eyeglasses = false;
        values[index].contacts = true;
        values[index].special_order = false;
      } else {
        values[index].item = "";
        values[index].contacts = false;
      }
    } else if (event.target.name === "Special Order/ OTC") {
      if (!values[index].special_order) {
        values[index].item = event.target.name;
        values[index].sunglasses = false;
        values[index].eyeglasses = false;
        values[index].contacts = false;
        values[index].special_order = true;
      } else {
        values[index].item = "";
        values[index].special_order = false;
      }
    }
    this.setState({ order: values });
  };

  handleReset = () => {
    this.setState({
      profile_id: "",
      phone_number: "",
      email: "",
      locker_id: "",
      order: [
        {
          invoice_number: "",
          item: "",
          sunglasses: false,
          eyeglasses: false,
          contacts: false,
          special_order: false,
        },
      ],
      items: [],
    });
  };

  handleAddOrder = () => {
    const values = [...this.state.order];
    values.push({
      invoice_number: "",
      item: "",
      sunglasses: false,
      eyeglasses: false,
      contacts: false,
      special_order: false,
    });
    this.setState({ order: values });
  };

  handleRemoveOrder = (index) => {
    const values = [...this.state.order];
    values.splice(index, 1);
    this.setState({ order: values });
  };

  handleEventLog = (event_params) => {
    fetch(`${process.env.REACT_APP_BASEURL}apis/i-ecom/status/events`, {
      method: "post",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(event_params),
    }).then((response) => {
      try {
        return response.text();
      } catch (error) {
        return null;
      }
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    for (let entry of this.state.order) {
      if (entry.item === "") {
        this.setState({ isChecked: false })
        this.setState({ errortext: "Please select a Item." })
        break;
      } else {
        this.setState({ isChecked: true })
        this.setState({ errortext: '' })
      }
    }
    if (this.state.isChecked) {
      if (this.state.view === false) {
        let orderdata = {};
        orderdata["profile_id"] = this.state.profile_id;
        orderdata["mobile_no"] = this.state.phone_number;
        orderdata["email"] = this.state.email;
        orderdata["bin_id"] = this.state.locker_id;
        orderdata["pickup_code"] = this.state.pickup_code;
        orderdata["stock_code"] = this.state.stock_code;
        orderdata["box_id"] = this.state.box_id;
        orderdata["type_id"] = assignmentStatus.ASSIGNED;
        this.state.order.forEach((value) => {
          let data = {};
          if (value.item !== "") {
            data["invoice_number"] = value.invoice_number;
            data["item"] = value.item;
            this.setState((prevState) => ({
              items: [data, ...prevState.items],
              orderDetails: [data, ...prevState.items],
              printDialogOpen: true,
            }));
          }
        });
        orderdata["items"] = this.state.items;
        setTimeout(() => {
          window.print();
          this.setState({
            printDialogOpen: false,
          });
          this.handleReset();
        }, 3000);
        if (orderdata !== null) {
          fetch(`${process.env.REACT_APP_BASEURL}apis/i-ecom/orders`, {
            method: "POST",
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user")).signInUserSession
                  .idToken.jwtToken,
            },
            body: JSON.stringify(orderdata),
          })
            .then((response) => response.json())
            .then((_data) => {
              const orderIds = _data && _data.map((item) => item.id);
              const user = JSON.parse(sessionStorage.getItem("user"));
              const user_id = user.username;
              let descriptions = "";
              descriptions =
                "Order is Assigned with stock code " +
                this.state.stock_code +
                " and pick up code " +
                this.state.pickup_code;
              const event_params = {
                event_name: EVENT_CRUD_TYPES.INSERT,
                event_type_name: EVENT_TYPES.ASSIGNED,
                description: descriptions,
                type_id: assignmentStatus.ASSIGNED,
                parent_account_id: this.state.parent_account_id,
                user_id: user_id,
                order_id: orderIds,
                box_id: this.state.box_id,
              };
              setTimeout(() => {
                this.ClearFields();
                this.gridApi.refreshInfiniteCache();
                this.handleEventLog(event_params);
              }, 1000);
            });
        }
      } else {
        this.setState({ orderDetails: [] });
        this.state.order.forEach((value) => {
          let data = {};
          if (value.item !== "") {
            data["invoice_number"] = value.invoice_number;
            data["item"] = value.item;
            this.setState((prevState) => ({
              orderDetails: [data, ...prevState.orderDetails],
              printDialogOpen: true,
            }));
          }
        });
        setTimeout(() => {
          window.print();
          this.setState({
            printDialogOpen: false,
          });
        }, 3000);
      }
    }
  };

  getLocationTypes = (locationTypeId, toBeCalled, type) => {
    fetch(process.env.REACT_APP_BASEURL + "locationtypes", {
      method: "GET",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((locationtypes) => {
        if (locationtypes) {
          const locationtypesdata = [];
          let newLocationtypes = [
            ...new Set(locationtypes && locationtypes.map((obj) => obj.name)),
          ].map((name) => {
            return (
              locationtypes && locationtypes.find((obj) => obj.name === name)
            );
          });
          console.log({ newLocationtypes });
          for (let i = 0; i < newLocationtypes.length; i++) {
            if (
              newLocationtypes[i].id !==
                "5e94cb81-ab9b-4e82-8b98-721a2d1794df" &&
              newLocationtypes[i].id !==
                "fd7c6330-8b9a-45e2-a1f6-f791db65f5d0" &&
              newLocationtypes[i].id !== "ee98b36c-a0e9-4cc4-a411-6c925ad442b6"
            ) {
              let tmp = {};
              tmp = {
                id: newLocationtypes[i].id,
                label: this.props.t(newLocationtypes[i].name_es),
                ...newLocationtypes[i],
              };
              locationtypesdata.push(tmp);
            }
          }
          if (toBeCalled) {
            if (!this.state.locationtype_id) {
              if (!locationTypeId) {
                this.getAllBoxes(
                  locationtypesdata &&
                    locationtypesdata[0] &&
                    locationtypesdata[0].id
                );
                this.setState({
                  locationtype_id:
                    locationtypesdata &&
                    locationtypesdata[0] &&
                    locationtypesdata[0].id,
                });
              } else {
                this.getAllBoxes(locationTypeId);
                this.setState({ locationtype_id: locationTypeId });
              }
            } else {
              if (!locationTypeId) {
                this.getAllBoxes(
                  locationtypesdata &&
                    locationtypesdata[0] &&
                    locationtypesdata[0].id
                );
              } else {
                this.getAllBoxes(locationTypeId);
              }
            }
            this.setState({ locationtype: locationtypesdata });
          } else if (type === "A11" || type === "A22" || type === "init") {
            if (!this.state.locationtype_id) {
              if (!locationTypeId) {
                this.getAllBoxes(
                  locationtypesdata &&
                    locationtypesdata[0] &&
                    locationtypesdata[0].id
                );
                this.setState({
                  locationtype_id:
                    locationtypesdata &&
                    locationtypesdata[0] &&
                    locationtypesdata[0].id,
                });
              } else {
                this.getAllBoxes(locationTypeId);
                this.setState({ locationtype_id: locationTypeId });
              }
            } else {
              if (!locationTypeId) {
                this.getAllBoxes(
                  locationtypesdata &&
                    locationtypesdata[0] &&
                    locationtypesdata[0].id
                );
              } else {
                this.getAllBoxes(locationTypeId);
              }
            }
            this.setState({ locationtype: locationtypesdata });
          }
        }
      });
  };

  getAssignedBins = (box_id) => {
    this.setState({ loader: true });
    let _binStatus = [];
    if (box_id) {
      fetch(process.env.REACT_APP_BASEURL + "binsbybox/" + box_id, {
        method: "GET",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((bins) => {
          this.setState({ loader: false });
          let deactivatedBins;
          _binStatus = JSON.parse(bins);
          if (_binStatus && _binStatus[0] && _binStatus[0].disabled_bins) {
            deactivatedBins = _binStatus[0].disabled_bins.toString().split(",");
            this.setState({ deactivatedBins: deactivatedBins });
          } else {
            this.setState({ deactivatedBins: [] });
          }
          this.setState({ BinStatus: _binStatus });
        });
    }
  };

  getBoxes(value) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "boxes", {
      method: "GET",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        try {
          const boxesResponse = response.json();
          return boxesResponse;
        } catch (error) {
          return null;
        }
      })
      .then((boxtypes) => {
        if (boxtypes) {
          this.setState({ boxdata: boxtypes });
          const boxTypes = boxtypes.map((type) => {
            return {
              id: type.id,
              label: type.name,
              accountId: type.parent_account_id,
            };
          });
          if (boxtypes.length > 0) {
            if (value === 0) {
              const defaultSelectedBoxId = boxTypes[0].id;
              if (this.state.box_id === null) {
                this.setState({ box_id: boxTypes[0].id });
              }
              this.getAssignedBins(defaultSelectedBoxId);
              this.getPharmacyDetails(defaultSelectedBoxId);
              this.getExpansionBins(defaultSelectedBoxId);
            } else {
              this.getAssignedBins(this.state && this.state.box_id);
              this.getPharmacyDetails(this.state && this.state.box_id);
              this.getExpansionBins(this.state && this.state.box_id);
            }
          }
          this.setState({
            boxTypes,
            printDialogOpen: false,
            loader: false,
          });
        } else {
          this.setState({ loader: false });
        }
      })
      .catch(() => {
        this.setState({ loader: false });
      });
  }

  getAllBoxes = (id) => {
    fetch(process.env.REACT_APP_BASEURL + "getBoxesById/" + id, {
      method: "get",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        if (data && data.length > 0) {
          let tmp = data.map((val) => {
            return {
              id: val.id,
              value: val.name,
              brandName: val.brandName,
              brandPhone: val.brandPhone,
              ...val,
            };
          });
          this.setState({
            boxDetails: tmp,
            boxTypeId: data && data[0].type_id,
            assignedPrescription: data && data[0],
            box_id: [undefined, "undefind", null, "null", ""].includes(
              localStorage.getItem("BoxId")
            )
              ? data && data[0].id
              : localStorage.getItem("BoxId"),
          });
          this.getBoxes();
        }
      });
  };

  getSelectedBin = (binId, position, flag) => {
    this.setState({
      selectedBinId: binId,
      box_position: position,
      isSelectedFlag: flag,
      locker_id: binId,
    });
  };

  getSelectedUnitName = (index) => {
    if (index === 1) {
      this.setState({
        selectedUnitName: "L60 (Locker Addon with 60 bins)",
      });
    } else if (index === 2) {
      this.setState({
        selectedUnitName: "HD36 (Locker Addon with 36 bins)",
      });
    } else if (index === 3) {
      this.setState({
        selectedUnitName: "Cool (Temp Controlled with 8 bins)",
      });
    } else {
      this.setState({
        selectedUnitName: "Locker (Main Unit with 46 bins)",
      });
    }
  };

  getPharmacyDetails(boxId) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "boxes/" + boxId, {
      method: "GET",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((phrmacydetail) => {
        this.setState({ loader: false });
        this.setState({
          pharmacyDetails: phrmacydetail && phrmacydetail[0],
          allow_multi_bins_pickup:
            phrmacydetail &&
            phrmacydetail[0] &&
            phrmacydetail[0].allow_multi_bins_pickup,
        });
        const accountId = phrmacydetail && phrmacydetail[0].parent_account_id;
        this.setState({ parent_account_id: accountId });
        this.getAccountDetails(accountId);
      });
  }

  getAccountDetails(accountId) {
    this.setState({ loader: true });
    fetch(
      process.env.REACT_APP_BASEURL + "account/" + accountId,
      {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      },
      accountId
    )
      .then((response) => response.json())
      .then((accountdetail) => {
        this.setState({ loader: false });
        this.setState({
          accountDetails: accountdetail && accountdetail[0],
        });
        console.log(accountdetail, "accountDetails");
      });
  }

  getExpansionBins(boxId) {
    fetch(process.env.REACT_APP_BASEURL + "box-expansions/" + boxId, {
      method: "GET",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((expansionDetails) => {
        let order = 0;
        let UnitLayout = [];
        let UnitIndex = 0;
        if (expansionDetails && expansionDetails.length > 0) {
          //Add Left side Unit
          UnitLayout = [];
          if (expansionDetails.findIndex((x) => x.direction === 1) > -1) {
            expansionDetails &&
              expansionDetails.map((unit, index) => {
                let boxlist = [];
                if (unit.direction === 1) {
                  boxlist = unit;
                  boxlist.order = order + 1;
                  boxlist.selectedUnitIndex = Math.abs(unit.box_position);
                  boxlist.pos = "L";
                  boxlist.box_position = unit.box_position;
                  order = order + 1;
                  UnitLayout.push(boxlist);
                  UnitIndex = UnitIndex + 1;
                }
                return true;
              });
          }
          if (UnitLayout.length > 0) {
            UnitLayout.reverse();
          }
          order = order + 1;
          UnitIndex = UnitIndex + 1;
          const boxesExpansions =
            expansionDetails &&
            expansionDetails.find((x) => x.box.id === boxId);
          if (boxesExpansions && boxesExpansions !== undefined) {
            if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== "" &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.Locker
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: "M",
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== "" &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.M22
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: "M22",
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== "" &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.M24
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: "M24",
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== "" &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.FASTLANE
            ) {
              this.fetchFastlaneBinMatrix();
              UnitLayout.push({
                id: -1,
                order: order,
                pos: "FASTLANE",
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: "M",
                selectedUnitIndex: 0,
                box_position: 0,
              });
            }
          }
          //Add Right side Unit
          if (expansionDetails.findIndex((x) => x.direction === 2) > -1) {
            expansionDetails &&
              expansionDetails.map((unit, index) => {
                let boxlist = [];
                if (unit.direction === 2) {
                  boxlist = unit;
                  boxlist.order = order + 1;
                  boxlist.selectedUnitIndex = unit.box_position;
                  boxlist.pos = "R";
                  boxlist.box_position = unit.box_position;
                  order = order + 1;
                  UnitLayout.push(boxlist);
                  UnitIndex = UnitIndex + 1;
                }
                return true;
              });
          }
        } else {
          order = order + 1;
          const boxes =
            this.state &&
            this.state.boxdata &&
            this.state.boxdata.length &&
            this.state.boxdata.length > 0 &&
            this.state.boxdata.find((x) => x.id === boxId);
          if (boxes && boxes !== undefined) {
            if (
              boxes &&
              boxes.type_id !== "" &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.Locker
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: "M",
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== "" &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.M22
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: "M22",
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== "" &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.M24
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: "M24",
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== "" &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.FASTLANE
            ) {
              this.fetchFastlaneBinMatrix();
              UnitLayout.push({
                id: -1,
                order: order,
                pos: "FASTLANE",
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: "M",
                selectedUnitIndex: 0,
                box_position: 0,
              });
            }
          }
        }
        this.setState({ expansionUnits: UnitLayout });
      });
  }

  getBoxesByID = (id) => {
    fetch(`${process.env.REACT_APP_BASEURL}boxes/${id}`, {
      method: "GET",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((boxes) => {
        if (boxes.length > 0) {
          this.setState(
            {
              courier_type:
                boxes[0].courier_type && boxes[0].courier_type.length > 0
                  ? boxes[0].courier_type.map((val) => {
                      return val.courier_type;
                    })
                  : [],
            },
            () => {
              if (this.state.courier_type.length > 0) {
                this.setState({
                  default_courier_selected:
                    boxes[0].courier_type[0].default_courier_type,
                });
              }
            }
          );
          let search = this.state.searchedItems;
          if (search) {
            search.location_notes = "";
            search.location_notes = boxes[0].location_notes;
            this.setState({ searchedItems: search });
          }
        }
      });
  };

  handleBoxChange = async (event) => {
    const boxtype =
      this.state &&
      this.state.boxdata &&
      this.state.boxdata.length &&
      this.state.boxdata.length > 0 &&
      this.state.boxdata.find((x) => x.id === event.target.value);
    this.setState({
      boxTypeId:
        boxtype && boxtype !== null && boxtype !== undefined && boxtype.type_id,
    });
    if (event.preventDefault) event.preventDefault();
    this.getBoxesByID(event.target.value);
    this.setState({ box_id: event.target.value });
    localStorage.setItem("BoxId", event.target.value);
    const box = {};
    box[event.target.id || event.target.name] = event.target.value;
    this.setState(box);
    if (this.state.locationtype_id !== LOCATION_TYPE.Kiosk) {
      return;
    }
    this.getPharmacyDetails(event.target.value);
    this.getExpansionBins(event.target.value);
    this.setState(box);
    if (this.state.selectedBinId !== "") {
      var items = document.getElementById(this.state.selectedBinId);
      items.style.removeProperty("background");
    }
    this.setState({
      hasError: false,
      selectedBinId: "",
      isBoxSelected: true,
    });
    this.getAssignedBins(event.target.value);
    this.getBoxes();
    this.gridApi.refreshInfiniteCache();
    this.ClearFields();
  };

  getPrescriptionDetails = (BinId) => {
    const bin_info = {
      id: this.state.box_id,
      bin_id: BinId,
    };
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "apis/i-ecom/orders/order/rxbybin", {
      method: "POST",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bin_info),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        if (data.length > 0) { 
          this.setState({
            loader: false,
            view: data[0].type_id === assignmentStatus.ASSIGNED || assignmentStatus.STOCKED ? true : false,
            orderStatus: data[0].type_id,
            profile_id: data[0].profile_id,
            phone_number: data[0].mobile_no,
            isCreteOrderDialogOpened: true,
            email: data[0].email,
            locker_id: data[0].bin_id,
            pickup_code: data[0].pickup_code,
            stock_code: data[0].stock_code,
            order: [],
            orderId: data && data.map(item => item.id)
          });
          let codes = {
            stockCode: data[0].stock_code,
            pickupCode: data[0].pickup_code,
          };
          localStorage.setItem("label-codes", JSON.stringify(codes));
          for (let i = 0; i < data.length; i++) {
            const values = [...this.state.order];
            values.push({
              invoice_number: data[i].invoice_id,
              item: data[i].item_name,
              sunglasses: data[i].item_name === "Sunglasses" ? true : false,
              eyeglasses: data[i].item_name === "Eyeglasses" ? true : false,
              contacts: data[i].item_name === "Contacts" ? true : false,
              special_order:
                data[i].item_name === "Special Order/ OTC" ? true : false,
            });
            this.setState({ order: values });
          }
        } else {
          this.setState({ loader: false });
        }
      });
  };

  handleRemove = () => {
    const updateStatusOfObj = {
      event_type_name: assignmentStatus.REMOVE_RX,
      type_id: assignmentStatus.REMOVE_RX,
      box_id: this.state.box_id,
      order_id: this.state.orderId,
      parentAccountId:this.state.parent_account_id
    };
    fetch(process.env.REACT_APP_BASEURL + "apis/i-ecom/status", {
      method: "put",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(updateStatusOfObj),
    }).then((response) => {
      this.ClearFields();
      this.setState({ isCreteOrderDialogOpened: false, })
      this.gridApi.refreshInfiniteCache();
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    });
  };

  onRowSelected = (event) => {
    let RowNode = event.api.getSelectedNodes();
    const BinId =
      RowNode && RowNode[0] && RowNode[0].data && RowNode[0].data.bin_id;
    if (BinId) {
      this.getPrescriptionDetails(BinId);
    }
  };

  handleRemind = () => {
    this.setState({ remindLoader: true })
    const smsObj = {
      phone: this.state.phone_number,
      pucode: this.state.pickup_code,
      boxId: this.state.box_id
    }
    fetch(process.env.REACT_APP_BASEURL + "apis/i-ecom/status/smsReminder", {
      method: "post",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(smsObj),
    }).then((response) => {
      this.setState({ remindLoader: false })
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    }).catch((err) => console.log(err));
  }

  render() {
    const {
      loader,
      stock_code,
      pickup_code,
      isCreteOrderDialogOpened,
      printDialogOpen,
      prescriptionUnAssign,
      prescriptionAssign,
      prescriptionView,
      prescriptionRemind,
    } = this.state;
    const { classes, t } = this.props;
    const columnDefs = [
      {
        headerName: "Profile",
        field: "profile_id",
      },
      {
        headerName: "Invoice",
        field: "invoice_id",
      },
      {
        headerName: "Mobile Phone",
        field: "mobile_no",
        sortable: false,
      },
      {
        headerName: "Email",
        field: "email",
        sortable: false,
      },
      {
        headerName: "Items",
        field: "item_name",
        sortable: false,
      },
      {
        headerName: "Locker Doors",
        field: "bin_id",
      },
    ];

    const legend = [
      { color: "#DADCDC", label: "Available" },
      {
        color:
          "linear-gradient(155deg, rgb(212,209,0) 0%, rgb(255,255,189) 90%)",
        label: "Assigned",
      },
      {
        color:
          "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(4, 144, 243) 90%)",
        label: "Hold",
      },
      {
        color:
          "linear-gradient(155deg, rgb(23,166,0) 0%, rgb(196,255,189) 90%)",
        label: "Stocked",
      },
      {
        color:
          "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)",
        label: "Deactivate",
      },
    ];

    return (
      <Box component="div">
        <Paper className={classNames(classes.paperRoot)}>
          {loader ? (
            <div className={classNames(classes.spinner)}>
              <img
                className={classNames(classes.spinnerImage)}
                src={spinner}
                alt="loading"
              />
            </div>
          ) : null}
          <div id="react-no-print" style={{ padding: "15px" }}>
            <div id="react-no-print" className={classNames(classes.root)}>
              <div
                id="react-no-print"
                className={classNames(classes.assignForm)}
              >
                <Grid container spacing={{ xs: 1, md: 2 }}>
                  <Grid item md={8} sx={{ p: 1.5 }}>
                    <Button
                      className={classNames(classes.primaryButton)}
                      variant="contained"
                      endIcon={<AddIcon />}
                      onClick={this.handleCreateOrderDialogClose}
                    >
                      {t("Assign.Optical.Create")}
                    </Button>
                  </Grid>

                  <Grid item md={4} sx={{ p: 1.5 }}>
                    <InputLabel htmlFor="box_id" style={{ fontSize: "13px" }}>
                      {t("Assign.Location")}
                    </InputLabel>
                    <Select
                      style={{ marginTop: "5px" }}
                      fullWidth={true}
                      value={this.state.box_id || ""}
                      onChange={this.handleBoxChange}
                      inputProps={{
                        name: "box_id",
                        id: "box_ids",
                      }}
                      variant="standard"
                    >
                      {this.state.boxDetails.length > 0 &&
                        this.state.boxDetails.map((type, index) => (
                          <MenuItem key={index} value={type.id} selected>
                            {type.value}
                          </MenuItem>
                        ))}
                    </Select>
                  </Grid>

                  <Grid item md={12}>
                    {this.state.box_id && (
                      <ILocalAGGrid
                        columnDefs={columnDefs}
                        defaultColDef={{
                          flex: 1,
                          minWidth: 150,
                          floatingFilter: true,
                          filter: "agTextColumnFilter",
                          filterParams: {
                            filterOptions: [
                              {
                                displayKey: "searchtext",
                                displayName: "Search Text",
                                predicate: (cellValue) => cellValue,
                              },
                            ],
                            maxNumConditions: 1,
                          },
                          resizable: true,
                          sortable: true,
                          menuTabs: [],
                        }}
                        rowSelection={"multiple"}
                        rowModelType={"infinite"}
                        cacheBlockSize={100}
                        gridHeight={250}
                        sideBar={false}
                        suppressMenuHide={false}
                        maxBlocksInCache={10}
                        enableSorting={false}
                        enableFilter={true}
                        floatingFilter={true}
                        enableColResize={true}
                        onRowSelected={this.onRowSelected}
                        onSelectionChanged={this.onSelectionChanged}
                        onGridReady={this.onGridReady}
                      />
                    )}
                  </Grid>
                </Grid>
                <div>
                  <Slide in={isCreteOrderDialogOpened} direction="up">
                    <div
                      style={{
                        marginTop: "2rem",
                        display:
                          isCreteOrderDialogOpened === false
                            ? "none"
                            : "inherit",
                        border: "1px solid #ddd",
                        borderRadius: "5px",
                        boxShadow: "1px 6px 8px 8px rgba(0,0,0,0.48)",
                      }}
                    >
                      <AppBar position="sticky">
                        <div
                          style={{
                            display: "flex",
                            backgroundColor: "#19AFE4",
                            justifyContent: "end",
                          }}
                        >
                          <IconButton
                            onClick={()=>{
                              this.setState({
                                isCreteOrderDialogOpened: false,
                                view: false,
                              });
                              this.handleReset();
                            }}
                          >
                            <CloseIcon sx={{ color: "white" }} />
                          </IconButton>
                        </div>
                      </AppBar>
                      <ValidatorForm
                        ref="form"
                        onSubmit={this.handleSubmit}
                        style={{ padding: "15px 25px" }}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={3}>
                            <TextValidator
                              sx={{ width: "80%", px: "1" }}
                              id="Profile"
                              label={t('Assign.Optical.Profile')}
                              name="profile_id"
                              value={this.state.profile_id}
                              onChange={this.handleChange}
                              variant="outlined"
                              inputProps={{ readOnly: this.state.view || !prescriptionAssign }}
                              validators={["required", "isNumber"]}
                              errorMessages={[
                                t("Assign.Optical.ProfileNumberError"),
                                t("Assign.Optical.ProfileNumberError1"),
                              ]}
                            />

                            <TextValidator
                              sx={{ mt: 3, width: "80%" }}
                              id="Mobile Phone"
                              label={t('Assign.Optical.MobilePhone')}
                              name="phone_number"
                              value={this.state.phone_number}
                              onChange={this.handleChange}
                              variant="outlined"
                              inputProps={{ readOnly: this.state.view || !prescriptionAssign }}
                              validators={["required"]}
                              errorMessages={[t('Assign.Optical.MobilePhoneError')]}
                            />

                            {/* <TextValidator
                              sx={{ mt: 3, width: "80%" }}
                              id="Email"
                              label={t('Assign.Optical.Email')}
                              name="email"
                              value={this.state.email}
                              onChange={this.handleChange}
                              inputProps={{ readOnly: this.state.view }}
                              variant="outlined"
                              validators={["isEmail"]}
                              errorMessages={[t('Assign.Optical.Email')]}
                            /> */}
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sx={{ overflow: "auto", maxHeight: "325px" }}
                          >
                            {this.state.order.map((order, index) => {
                              return (
                                <div
                                  style={{
                                    display: "flex",
                                    paddingBottom: "1rem",
                                  }}
                                >
                                  <div>
                                    {index > 0 ? (
                                      <IconButton
                                        onClick={() =>
                                          this.handleRemoveOrder(index)
                                        }
                                        disabled={this.state.view}
                                      >
                                        <RemoveCircleOutlineOutlinedIcon
                                          sx={{
                                            mt: "0.5rem",
                                            fontSize: "1.5rem",
                                            color: "secondary",
                                          }}
                                        />
                                      </IconButton>
                                    ) : (
                                      <IconButton
                                        onClick={this.handleAddOrder}
                                        disabled={this.state.view}
                                        inputProps={{
                                          readOnly: this.state.view || !prescriptionAssign,
                                        }}
                                      >
                                        <AddCircleIcon
                                          sx={{
                                            mt: "0.5rem",
                                            fontSize: "1.5rem",
                                            color: "secondary",
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                  </div>
                                  <TextValidator
                                    id="Invoice"
                                    label={t('Assign.Optical.Invoice')}
                                    name="invoice_number"
                                    value={order.invoice_number}
                                    onChange={(e) => this.handleOrder(index, e)}
                                    variant="outlined"
                                    inputProps={{
                                      readOnly: this.state.view,
                                    }}
                                    validators={["required"]}
                                    disabled={!prescriptionAssign}
                                    errorMessages={[t('Assign.Optical.InvoiceError')]}
                                  />

                                  <div style={{ marginLeft: "1rem" }}>
                                    <FormLabel
                                      component="legend"
                                      sx={{
                                        fontWeight: "bold",
                                        fontSize: "1rem",
                                      }}
                                    >
                                     {t('Assign.Optical.Items')}
                                    </FormLabel>
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            fontSize: 18,
                                          },
                                        }}
                                        control={
                                          <Checkbox
                                            name="Sunglasses"
                                            checked={order.sunglasses}
                                            disabled={this.state.view || !prescriptionAssign}
                                            onChange={(e) =>
                                              this.handleOrder(index, e)
                                            }
                                            color="primary"
                                          />
                                        }
                                        label={t('Assign.Optical.Sunglasses')}
                                      />
                                      <FormControlLabel
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            fontSize: 18,
                                          },
                                        }}
                                        control={
                                          <Checkbox
                                            name="Eyeglasses"
                                            checked={order.eyeglasses}
                                            disabled={this.state.view || !prescriptionAssign}
                                            onChange={(e) =>
                                              this.handleOrder(index, e)
                                            }
                                            color="primary"
                                          />
                                        }
                                        label={t('Assign.Optical.Eyeglasses')}
                                      />
                                      <FormControlLabel
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            fontSize: 18,
                                          },
                                        }}
                                        control={
                                          <Checkbox
                                            name="Contacts"
                                            checked={order.contacts}
                                            disabled={this.state.view || !prescriptionAssign}
                                            onChange={(e) =>
                                              this.handleOrder(index, e)
                                            }
                                            color="primary"
                                          />
                                        }
                                        label={t('Assign.Optical.Contacts')}
                                      />
                                      <FormControlLabel
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            fontSize: 18,
                                          },
                                        }}
                                        control={
                                          <Checkbox
                                            name="Special Order/ OTC"
                                            checked={order.special_order}
                                            disabled={this.state.view || !prescriptionAssign}
                                            onChange={(e) =>
                                              this.handleOrder(index, e)
                                            }
                                            color="primary"
                                          />
                                        }
                                        label={t('Assign.Optical.SpecialOrder')}
                                      />
                                    </FormGroup>
                                  </div>
                                </div>
                              );
                            })}
                          </Grid>
                          <Grid item xs={1}>
                            <TextValidator
                              id="Locker Selected"
                              name="Locker Selected"
                              label={t('Assign.Optical.Door')}
                              value={this.state.locker_id}
                              variant="outlined"
                              validators={["required"]}
                              errorMessages={[t('Assign.Optical.DoorError')]}
                              inputProps={{ readOnly: this.state.view }}
                              disabled={!prescriptionAssign}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "column",
                                padding: "0 10px",
                              }}
                            >
                              {prescriptionRemind ? (
                                <Button
                                  className={classNames(classes.primaryButton)}
                                  sx={{ mb: 2 }}
                                  variant="contained"
                                  disabled={this.state.remindLoader}
                                  onClick={() => this.handleRemind()}
                                >
                                  {this.state.remindLoader ? <CircularProgress color="inherit" size={20} /> :
                                    t('Assign.Optical.Remind')}
                                </Button>) : null}
                              <Button
                                className={classNames(classes.primaryButton)}
                                sx={{ mb: 2 }}
                                variant="contained"
                                disabled={this.state.view}
                                onClick={() => this.handleReset()}
                              >
                                {t('Assign.Optical.Reset')}
                              </Button>
                              <Button
                                className={classNames(classes.primaryButton)}
                                sx={{ mb: 2 }}
                                variant="contained"
                                type="submit"
                                disabled={!prescriptionAssign}
                              >
                                {this.state.view ? t('Assign.Optical.Print') : t('Assign.Optical.SavePrint')}
                              </Button>
                              {this.state.view && prescriptionUnAssign && this.state.orderStatus !== assignmentStatus.STOCKED  ? (
                                <Button
                                  className={classNames(classes.primaryButton)}
                                  sx={{ mb: 2 }}
                                  variant="contained"
                                  onClick={() => this.handleRemove()}
                                >
                                  {t('Assign.Optical.Remove')}
                                </Button>
                              ) : (
                                ""
                              )}
                              {!this.state.isChecked && <p style={{color:"red",fontSize:"16px"}}>{this.state.errortext}</p>}
                            </Box>
                          </Grid>
                        </Grid>
                      </ValidatorForm>
                    </div>
                  </Slide>
                </div>
              </div>
              <div id="react-no-print" key="BoxLayout">
                <React.Fragment>
                  <Grid container sx={{ m: "0px", mt: "2%" }}>
                    <Grid item xs={9}>
                      <BoxLayout
                        BinStatus={this.state.BinStatus}
                        deactivatedBins={this.state.deactivatedBins}
                        selectedBinId={this.state.selectedBinId}
                        expansionUnits={this.state.expansionUnits}
                        getPrescriptionDetails={this.getPrescriptionDetails}
                        getSelectedBin={this.getSelectedBin}
                        getSelectedUnitName={this.getSelectedUnitName}
                        currentTabIndex={this.state.expansionUnits.findIndex(
                          (x) =>
                            x.pos === "M" ||
                            x.pos === "M22" ||
                            x.pos === "FASTLANE" ||
                            x.pos === "M24"
                        )}
                        boxTypeId={this.state.boxTypeId}
                        fastlaneBinsMatrix={this.state.fastlaneBinsMatrix}
                        isViewPermissionAllowed={prescriptionView}
                        t={t}
                      />
                    </Grid>
                    <Grid item xs={3} sx={{ m: "0px", mt: "2%" }}>
                      <List>
                        {legend.map((value) => {
                          return (
                            <ListItem
                              disablePadding
                              sx={{
                                cursor: "pointer",
                                margin: "0 10px",
                              }}
                            >
                              <ListItemIcon>
                                <span
                                  style={{
                                    background: value.color,
                                    height: "20px",
                                    width: "20px",
                                    border: "1px solid #888",
                                    borderRadius: "50%",
                                  }}
                                >
                                  &nbsp;
                                </span>
                              </ListItemIcon>
                              <ListItemText primary={value.label} />
                            </ListItem>
                          );
                        })}
                      </List>
                    </Grid>
                  </Grid>
                  <Grid container sx={{ m: "0px", pl: "1rem", pr: "1rem" }}>
                    <Grid item xs={12}>
                      <Table>
                        <TableRow>
                          <TableCell
                            className={classNames(classes.TableHeadTop)}
                          >
                            <span style={{ color: "#a4a6a5" }}>
                              {t("Unplugged.StockCode")}:
                            </span>
                            &nbsp;&nbsp; <span>{stock_code}</span>
                          </TableCell>
                          <TableCell
                            className={classNames(classes.TableHeadTop)}
                          >
                            <span style={{ color: "#a4a6a5" }}>
                              {t("Unplugged.PUCode")}:
                            </span>
                            &nbsp;&nbsp; <span>{pickup_code}</span>
                          </TableCell>
                        </TableRow>
                      </Table>
                    </Grid>
                  </Grid>
                </React.Fragment>
              </div>
            </div>
          </div>
        </Paper>
        <PrintTemplate>
          <Dialog
            open={printDialogOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              sx: {
                borderRadius: "0px",
                width: "255px",
                height: "500px",
              },
            }}
          >
            <DialogContent sx={{ p: "10px" }}>
              <RetailLabelTemplate
                style={{ display: "none" }}
                boxId={this.state.box_id || ""}
                ref={(el) => (this.componentRef = el)}
                accountDetails={this.state.accountDetails || ""}
                pharmacyDetails={this.state.pharmacyDetails || ""}
                boxDetails={this.state.boxDetails}
                connectionType={0}
                t={t}
                ProfileNumber={this.state.profile_id}
                orderDetails={this.state.orderDetails}
              />
            </DialogContent>
          </Dialog>
        </PrintTemplate>
      </Box>
    );
  }
}

export default withStyles(styles)(withTranslation()(CreateOrder));



// WEBPACK FOOTER //
// ./src/components/retail-orders/index.js